import {SENT_MESSAGE} from '../actions/contacts'

export default function contactForm(state = {
	sentMessage: null,
	successMsg: null
}, action) {
	let newState
	switch (action.type) {
	case SENT_MESSAGE:
		newState = action.contactForm
		return {
			...newState
		}
	default:
		return state
	}
}